import { useState } from "react";
import { MiSearchAutocomplete } from "@miplatform/components";
import { useDebounce } from "@miplatform/hooks";
import { IInspectionAttempt, IInspectionTemplate } from "@miplatform/types";
import { MenuItemProps } from "@mui/material";
import { InspectionSearchOption } from "./InspectionSearchOption";
import { InspectionOption, useInspectionSearch } from "./useInspectionSearch";

export const InspectionSearch = ({
  onSelect,
  templates,
}: {
  onSelect: (inspection: IInspectionAttempt) => void;
  templates: { [key: string]: IInspectionTemplate };
}) => {
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 300);
  const { inspectionOptions, getInspectionOptions, loading } =
    useInspectionSearch({ search: debouncedSearch });

  const handleSearchChange = (value: string) => {
    setSearch(value);
  };

  const handleClearSearch = () => {
    setSearch("");
  };

  return (
    <MiSearchAutocomplete
      placeholder="Search Inspections"
      search={search}
      debouncedSearch={debouncedSearch}
      options={inspectionOptions ?? []}
      onSearchChange={handleSearchChange}
      onClearSearch={handleClearSearch}
      renderOption={(
        props: MenuItemProps,
        option: InspectionOption,
        onClose: () => void
      ) => {
        return (
          <InspectionSearchOption
            key={option.id}
            option={option}
            props={props}
            close={onClose}
            templates={templates}
            onSelect={onSelect}
          />
        );
      }}
      width="350px"
      loading={loading}
      getOptions={getInspectionOptions}
      noOptionsText="No inspections found."
    />
  );
};
